<template lang="pug">
  .login
    .login__preview.login__wrap
      .login__title
        h1 Ilavco -We make Amazon returns seamless!
      .login__footer
        .login__info
          .login__copyright
            span &copy; Ilvaco
    .login__signin.login__wrap
      .login__signup-label
        span Don't have an account yet?
        | &nbsp;&nbsp;
        router-link.link(to="/register") Sign Up!
      .login__body
        .login__form-title
          h2 Password recovery
        form.login__form.form__groups(@submit.prevent="submit")
          .form__group
            input.form-control(placeholder="Email", type="text", v-model="email", name="email", autocomplete="off")
          .form__actions
            .form__link-forgot
              router-link.link(to="/login") Back to Sign In
            button.btn.btn-primary(type="submit") Submit
</template>

<script>
export default {
  data() {
    return {
      email: '',
    };
  },
};
</script>

<style src="./forgot-password.styl" lang="stylus" scoped></style>
